<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2 header-toolbar">
      <div class="d-flex align-center justify-space-between flex-wrap">
        <div class="title-stack">
          <span class="title">Académico: Solicitud Modificación de Calificaciones</span>
          <small class="subtitle">Filtra por programa, módulo, estado o fechas</small>
        </div>

        <div class="d-flex align-center">

          <!-- <v-col cols="12" md="6" lg="4" class="d-flex align-center">
            <v-btn small color="primary" class="mr-2" @click="abrirDialogoFiltros">
              <v-icon left small>mdi-filter</v-icon>
              Filtrar
            </v-btn>
            <v-btn small text @click="limpiarFiltros" :disabled="!hayFiltros">Limpiar filtros</v-btn>
          </v-col> -->
          <!-- <v-chip v-if="metadatos?.total" class="mr-2" label small color="primary" text-color="white">
            {{ metadatos.total }} solicitudes
          </v-chip>
          <v-btn small text @click="limpiarFiltros" :disabled="!hayFiltros">Limpiar filtros</v-btn> -->
        </div>
      </div>

      <v-card class="filters-card" flat>
        <v-row dense align="center">

          <v-col cols="12" v-if="filtrosActivos.length">
            <div class="d-flex align-center flex-wrap filtros-activos mb-2">
              <span class="mr-2 body-2 font-weight-medium">Filtrando por:</span>
              <v-chip
                v-for="filtro in filtrosActivos"
                :key="filtro"
                small
                class="mr-1 mb-1"
                outlined
                color="primary"
                text-color="primary">
                {{ filtro }}
              </v-chip>
            </div>
          </v-col>

          <v-col cols="12" md="6" lg="4" class="d-flex align-center">
            <v-pagination
              class="custom-pagination mr-2"
              v-model="pagina"
              :length="metadatos?.totalPaginas || 0"
              :total-visible="7"
              @input="listar" />
            <v-select
              class="items-por-pagina"
              :items="[10, 25, 50, 75, 100, 500]"
              label="Items"
              v-model="itemsPorPagina"
              outlined
              dense
              hide-details
              :disabled="solicitudes.length === 0"
              @change="cambiarPagina" />
          </v-col>

        </v-row>
      </v-card>
    </v-toolbar-title>

    <DialogFiltroSolicitud
      ref="dialogFiltrosRef"
      :solicitudes="solicitudes"
      :modulos="modulos"
      :estadosSelect="estadosSelect"
      :cargandoProgramas="cargandoProgramas"
      :cargandoModulos="cargandoModulos"
      :filtrosIniciales="filtrosForm"
      @aplicar="aplicarFiltros"
      @cargar-modulos="cargarModulosDialog" />

    <v-row dense>
      <v-col cols="12" md="9" xl="10">
        <v-btn class="mx-1" small :disabled="solicitud == null" title="Ver" @click="verSolicitud">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
<!-- 
        <v-btn class="mx-1" small :disabled="!puedeEnviar" title="Enviar" @click="confirmarEnvio">
          <v-icon>mdi-send</v-icon>
          Enviar
        </v-btn>

        <v-btn class="mx-1" small :disabled="!puedeSincronizar" title="Sincronizar" @click="confirmarSincronizacion">
          <v-icon>mdi-sync</v-icon>
          Sincronizar
        </v-btn> -->

        <v-btn class="mx-1" small title="Recargar" @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="buscar" />
      </v-col>

      <v-col cols="12" v-if="!cargandoSolicitudes">
        <ListadoSolicitudesModificacionCalificacion
          ref="listadoRef"
          :items="solicitudes"
          :cargando="cargandoSolicitudes"
          @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar">
      <template>
        <p v-html="confirmacion.mensaje"></p>
      </template>
    </ConfirmacionAccion>

    <DialogVerSolicitud
      ref="dialogVerSolicitudRef"
      @solicitud-revisada="manejarSolicitudRevisada" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoSolicitudesModificacionCalificacion from '../components/ListadoSolicitudesModificacionCalificacion.vue';
import SolicitudModificacionCalificacionService from '../../services/solicitud-modificacion-calificacion.service';
import DialogFiltroSolicitud from '../components/dialogs/DialogFiltroSolicitud.vue';
import ConfirmacionAccion from '@/views/pagos/components/ConfirmacionAccion.vue';
import DialogVerSolicitud from '../components/dialogs/DialogVerSolicitud.vue';
import {
  ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION,
  ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LIST,
} from '../../utils/constantes';
import { ACCIONES_A_CONFIRMAR } from '@/views/pagos/utils/constantes';

export default {
  name: 'SolicitudModificacionCalificacionLayout',
  components: {
    ListadoSolicitudesModificacionCalificacion,
    DialogFiltroSolicitud,
    ConfirmacionAccion,
    DialogVerSolicitud,
  },
  data() {
    return {
      nombreItem: 'Solicitud Modificación de Calificación',
      solicitud: null,
      // solicitudes: [],
      pagina: 1,
      itemsPorPagina: Number(localStorage.getItem(`${this.$route.name}-itemsPorPagina`)) || 10,
      metadatos: null,
      cargando: false,
      accionesAConfirmar: ACCIONES_A_CONFIRMAR,
      confirmacion: {
        titulo: 'Acción a confirmar',
        mensaje: '¿Está seguro de realizar esta acción?',
        realizandoAccion: false,
        fnAceptar: () => {
          window.alert("No se ha definido la función 'fnAceptar'");
        },
      },
      busqueda: null,
      retardo: null,
      searchQuery: '',
      solicitudes: [],
      modulos: [],
      programaId: null,
      moduloId: null,
      estado: null,
      gestion: null,
      fechaInicio: null,
      fechaFin: null,
      estados: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION,
      estadosSelect: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LIST,
      cargandoProgramas: false,
      cargandoSolicitudes: false,
      cargandoModulos: false,
      filtrosForm: {
        programaId: null,
        moduloId: null,
        estado: null,
        gestion: null,
        fechaInicio: null,
        fechaFin: null,
        busqueda: null,
      },
    };
  },
  created() {
    this.obtenerSolicitudes();
    // this.obtenerProgramas();
    // this.obtenerModulos();
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      this.listarRestableciendoPagina();
    },
  },
  computed: {
    hayFiltros() {
      return Boolean(
        this.programaId ||
          this.moduloId ||
          this.estado !== null ||
          this.gestion ||
          this.fechaInicio ||
          this.fechaFin ||
          (this.busqueda && this.busqueda.trim() !== ''),
      );
    },
    filtrosActivos() {
      const chips = [];

      if (this.programaId) {
        const programa = this.programas.find((p) => p.id === this.programaId);
        chips.push(`Programa: ${programa?.nombre || this.programaId}`);
      }

      if (this.moduloId) {
        const modulo = this.modulos.find((m) => m.id === this.moduloId);
        chips.push(`Módulo: ${modulo?.nombre || this.moduloId}`);
      }

      if (this.estado !== null) {
        const estadoLabel = this.estadosSelect.find((e) => e.value === this.estado)?.text || this.estado;
        chips.push(`Estado: ${estadoLabel}`);
      }

      if (this.gestion) {
        chips.push(`Gestión: ${this.gestion}`);
      }

      if (this.fechaInicio) {
        chips.push(`Desde: ${this.fechaInicio}`);
      }

      if (this.fechaFin) {
        chips.push(`Hasta: ${this.fechaFin}`);
      }

      if (this.busqueda && this.busqueda.trim() !== '') {
        chips.push(`Texto: ${this.busqueda.trim()}`);
      }

      return chips;
    },
    puedeEnviar() {
      return (
        this.solicitud &&
        [
          this.estados.PENDIENTE,
          this.estados.GENERADO,
        ].includes(this.solicitud.estado)
      );
    },
    puedeSincronizar() {
      return this.solicitud && [this.estados.APROBADA].includes(this.solicitud.estado);
    },
  },
  methods: {
    selectItem(item) {
      this.solicitud = item;
    },
    updateSearchQuery(val) {
      this.$refs.listadoRef?.updateSearchQuery?.(val);
    },
    async obtenerDatosPaginadosConNotificacion(fnServicioListar, llave, llaveMetadatos, nombreRecurso, params = {}) {
      this.cargando = true;

      try {
        const { data } = await fnServicioListar({ params });
        const { datos, mensaje, metadatos } = data;

        this[llave] = datos;
        this[llaveMetadatos] = metadatos;
        this.$notify({
          group: 'notifications',
          title: nombreRecurso.toUpperCase(),
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const mensaje = error?.response ? error.response?.data?.mensaje : error.message;

        this[llave] = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    listarRestableciendoPagina() {
      if (this.pagina !== 1) {
        this.pagina = 1;
      }

      this.listar();
    },
    cambiarPagina() {
      this.listarRestableciendoPagina();
      localStorage.setItem(`${this.$route.name}-itemsPorPagina`, this.itemsPorPagina);
    },
    buscar(q) {
      clearTimeout(this.retardo);
      this.retardo = setTimeout(() => {
        this.busqueda = q;
        this.listarRestableciendoPagina();
      }, 500);
    },
    abrirDialogoFiltros() {
      this.filtrosForm = {
        programaId: this.programaId,
        moduloId: this.moduloId,
        estado: this.estado,
        gestion: this.gestion,
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
        busqueda: this.busqueda,
      };

      this.obtenerModulos(this.filtrosForm.programaId);
      this.$refs.dialogFiltrosRef?.abrir(this.filtrosForm);
    },
    aplicarFiltros(filtros) {
      this.programaId = filtros.programaId;
      this.moduloId = filtros.moduloId;
      this.estado = filtros.estado;
      this.gestion = filtros.gestion;
      this.fechaInicio = filtros.fechaInicio;
      this.fechaFin = filtros.fechaFin;
      this.busqueda = filtros.busqueda;
      this.searchQuery = filtros.busqueda || '';
      this.listarRestableciendoPagina();
    },
    limpiarFiltros() {
      this.programaId = null;
      this.moduloId = null;
      this.estado = null;
      this.gestion = null;
      this.fechaInicio = null;
      this.fechaFin = null;
      this.busqueda = null;
      this.searchQuery = '';
      this.listarRestableciendoPagina();
    },
    listar() {
      const params = {
        pagina: this.pagina,
        itemsPorPagina: this.itemsPorPagina,
        busqueda: this.busqueda,
        programaId: this.programaId,
        moduloId: this.moduloId,
        estado: this.estado,
        gestion: this.gestion,
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
        sedeId: this.$store.state.CARGO.sede?.id,
        programaModuloId: this.moduloId,
      };

      this.obtenerSolicitudes(params);

      this.solicitud = null;
    },
    async getResponseAccion(accion) {
      if (accion === this.accionesAConfirmar.ELIMINAR) {
        return await SolicitudModificacionCalificacionService.remove(this.solicitud.id);
      }

      return null;
    },
    verSolicitud() {
      if (!this.solicitud) {
        return;
      }

      this.$refs.dialogVerSolicitudRef?.abrir(this.solicitud);
    },
    manejarSolicitudRevisada(data) {
      this.solicitudes=this.solicitudes.map(solicitud=>{
        if(solicitud.id===data.solicitudId){
          return {...solicitud,estadoSolicitud:data.estado, observacion:data.motivo};
        }
        return solicitud;
      })
    },
    confirmarEnvio() {
      if (!this.solicitud || !this.puedeEnviar) {
        return;
      }

      this.confirmacion.titulo = 'Enviar solicitud';
      this.confirmacion.mensaje = `¿Enviar la solicitud N° ${this.solicitud.id}?`;
      this.confirmacion.fnAceptar = this.enviar;
      this.$refs.confirmacionRef.abrir();
    },
    confirmarSincronizacion() {
      if (!this.solicitud || !this.puedeSincronizar) {
        return;
      }

      this.confirmacion.titulo = 'Sincronizar solicitud';
      this.confirmacion.mensaje = `¿Sincronizar la solicitud N° ${this.solicitud.id}?`;
      this.confirmacion.fnAceptar = this.sincronizar;
      this.$refs.confirmacionRef.abrir();
    },
    async enviar() {
      this.confirmacion.realizandoAccion = true;

      try {
        const response = await SolicitudModificacionCalificacionService.enviar(this.item.id);
        this.$refs.confirmacionRef.cerrar();
        this.listar();
        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: response?.data?.mensaje || 'Solicitud enviada correctamente',
          type: 'success',
        });
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje;
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'No se pudo enviar la solicitud',
          type: 'error',
        });
      } finally {
        this.confirmacion.realizandoAccion = false;
      }
    },
    async sincronizar() {
      this.confirmacion.realizandoAccion = true;

      try {
        const response = await SolicitudModificacionCalificacionService.sincronizar(this.solicitud.id);
        this.$refs.confirmacionRef.cerrar();
        this.listar();
        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: response?.data?.mensaje || 'Solicitud sincronizada correctamente',
          type: 'success',
        });
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje;
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'No se pudo sincronizar la solicitud',
          type: 'error',
        });
      } finally {
        this.confirmacion.realizandoAccion = false;
      }
    },

    async obtenerSolicitudes(params = {}) {
      // this.cargando = true;
      this.cargandoSolicitudes = true;
      // eslint-disable-next-line no-console
      // console.log(params);
      try {
        const { data } = await SolicitudModificacionCalificacionService.solicitudes(params);
        this.solicitudes = data?.datos || [];
        this.metadatos = data?.metadatos || null;
      } catch (error) {
        this.solicitudes = [];
        this.metadatos = null;
      } finally {
        // this.cargando = false;
        this.cargandoSolicitudes = false;
      }
    },
    cargarModulosDialog(programaId) {
      this.filtrosForm.moduloId = null;
      this.obtenerModulos(programaId);
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

.header-toolbar {
  border-bottom: 1px solid #d4dbe0;
}

.title {
  font-weight: 600;
}

.subtitle {
  color: #6a6f7a;
}

.filters-card {
  background: #f6f8fb;
  border-radius: 8px;
  padding: 10px 12px;
  margin-top: 12px;
}

.filtros-activos {
  background: #eef2f7;
  border-radius: 6px;
  padding: 6px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>
